import React, { useEffect, useState } from "react";
import _ from "lodash";
import Form from "forms/Form";
import formWrapper from "hoc/formWrapper";
import { consoleLog, setAuthToken } from "utils/functions";
import ConfirmLoginForm from "forms/ConfirmLoginForm/ConfirmLoginForm";
import client from "../../client/client";

const LoginForm = () => {
    const [verified2fa, setVerified2fa] = useState(true);
    const [qrCodeSource, setQrCodeSource] = useState();
    const [defaultValues, setDefaultValues] = useState({});
    const endpoint = `login`;

    useEffect(() => {
        return () => null
    }, [])

    const onChange = (key, value) => {
        setDefaultValues({
            ...defaultValues,
            [key]: value
        });
    }

    const getValue = (name, type) => {

        const value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;
        return value;
    };

    const onSubmit = (data) => {
        consoleLog("onSubmi", data);
        if (data?.token) {
            setAuthToken(data.token)
            client.defaults.headers.common["Authorization"] = "Bearer " + data.token;
            if (data?.qr_code || data?.qr_code === false) {
                setTimeout(() => {
                    setVerified2fa(false)
                    setQrCodeSource(data.qr_code)
                }, 1000)
            }
            else {
                window.location.replace("/");
            }
        }
    }

    const onVerified = (verified) => {
        if (verified) {
            window.location.replace("/");
        }
    }
    const fields = 1
        ? [

            {
                elementType: "email",
                //   helperText:
                // "Event title is just for internal use (~255 character count maximum)",
                id: "email",
                name: "email",
                invalidText: "Invalid error message.",
                labelText: "Insert your email",
                placeholder: "Email",
                value: getValue("email"),
                rules: {
                    required: true,
                },
            },
            {
                elementType: "password",
                //   helperText: "Insert support email address",
                id: "password",
                name: "password",
                invalidText: "This must be a valid email address",
                labelText: "Password",
                placeholder: "Insert password",
                value: getValue("password"),
                rules: {
                    pattern:
                        "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$",
                },
            },
        ]
        : [];

    return (
        <>
            {
                verified2fa ? (
                    <Form
                        fields={fields}
                        endpoint={endpoint}
                        isLogin={true}
                        // method={"put"}
                        loaded={true}
                        blockTouched={true}
                        onChange={(name, value) => onChange(name, value)}
                        onSubmit={(evtData) => onSubmit(evtData)}
                        afterPostOKMessage={"Login succeded!"}
                        afterPostKOMessage={"Something was wrong"}
                        postingMessage={"Please wait..."}
                        hasStandardFooter
                    />
                ) : (
                    <ConfirmLoginForm qrCodeSource={qrCodeSource} onVerified={onVerified} />
                )
            }
        </>
    );
};

export default formWrapper(LoginForm);
